import React from "react";
import StageSteps from "../../components/StageSteps";
import "../../styles/GrowthStage.css";
import BrowseVideos from "../../components/BrowseVideos/BrowseVideos";
import StageVision from "../../components/Vision/StageVision";
import { Stages } from "../../Utils/Stages";
import StageDetails from "../../components/StagesComponents/StageDetails";
import { useNavigate } from "react-router-dom";

const ValleyStageDetails = () => {
  const { helpSteps, valleyStage } = Stages.ValleyStage;
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/contact-us", { state: { scrollToForm: true } }); // Pass state
  };
  return (
    <div className="valley-container">
      <div className="valley-innercontainer">
        <div>
          <h1 className="text-white valley-title">
            Navigate{" "}
            <span style={{ color: "var(--text-secondary)" }}>The Valley</span>{" "}
            Of <br className="valley-mobile" /> Challenges And Build Momentum
          </h1>
          <div>
            <div>
              <p className="valley-desc">
                We’re here to guide you through the crucial valley
                stage-overcoming hurdles, fine-tuning your product, and
                preparing for sustainable growth
              </p>
            </div>
          </div>

          <div className="valley-desktop">
            <div>
              <p
                style={{ color: "white", paddingTop: "1em" }}
                className="price-desc"
              >
                Customised startup consultations starting only at 75K/month
              </p>
            </div>

            <div>
              <button className="valley-btn" onClick={handleGetStarted}>Tell us more...</button>
              <br />
            </div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            className="valley-img"
            src="/valleystage.svg"
            alt="rocket_img"
            height={540}
          />
        </div>
      </div>
      <div className="valley-mobile">
        <div>
          <p
            style={{ color: "white", paddingTop: "1em" }}
            className="price-desc"
          >
            Customised startup consultations starting
            <br />
            only at 75K/month
          </p>
        </div>

        <div>
          <button className="valley-btn" onClick={handleGetStarted}>Tell us more...</button>
          <br />
        </div>
      </div>
      {/* WHAT IS VALLEY */}
      <div className="what-is-valley">
        <div style={{ width: "90%", margin: "auto" }}>
          <p className="what-is-valley-title" style={{ textAlign: "center" }}>
            What Is The
            <span style={{ color: "var(--text-secondary)" }}>
              {" "}
              Valley Stage?
            </span>
          </p>
        </div>
        <div style={{ width: "90%", margin: "auto" }}>
          <p className="what-is-valley-desc">
            The Valley Stage marks your startup's transition from concept to early operations. Challenges include securing funding, building a viable product, and attracting early adopters.
          </p>
        </div>
        {/* IMAGE AND INFO */}
        <div className="valley-left-right-container">
          <div className="valley-left">
            <img
              src="/valleystage2.svg"
              className="valley-img"
              alt="valley_image"
            />
          </div>
          <div id="valley-right">
            {valleyStage.map((stage, index) => (
              <StageDetails key={index} stage={stage} />
            ))}
          </div>
        </div>
      </div>
      <StageSteps
        title={"How We Can Help You In The Valley Stage ?"}
        helpSteps={helpSteps}
      />
      <div style={{ textAlign: "center" }}>
        <BrowseVideos backgroundType="black" />
      </div>
      <div style={{ textAlign: "center" }}>
        <StageVision />
      </div>
    </div>
  );
};

export default ValleyStageDetails;
